var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"err-page"},[_c('div',{staticClass:"hit-the-floor"},[_vm._v("404")]),_c('div',{staticClass:"keep-on-record"},[_vm._v(" ©Copy Right 2018-2022 "),_c('a',{attrs:{"href":"https://beian.miit.gov.cn/#/Integrated/index"}},[_vm._v("deebike.com")]),_vm._v(" 无锡的卢电子科技有限公司 版权所有 ")])])
}]

export { render, staticRenderFns }